<template>
  <BaseSnack :type="type">
    <div :class="$style.content" class="d-flex flex-column gap-s">
      <div v-for="(message, index) in messages" :key="index">
        <div v-if="message.field || message.code" :class="$style.line" class="title-five">
          {{ message.field ?? $gettext("Fehler") }}
        </div>
        <div v-if="message.message" :class="[$style.line, $style.message]">
          {{ message.message }}
        </div>
      </div>
    </div>
  </BaseSnack>
</template>

<script lang="ts" setup>
import BaseSnack from "@/components/BaseSnack.vue";
import type { SnackType } from "@/components/snackType";

import type { ValidationMessage } from "../../types/api-types";

withDefaults(
  defineProps<{
    type?: SnackType;
    messages: Partial<ValidationMessage>[];
  }>(),
  {
    type: "neutral",
  },
);
</script>

<style module lang="scss">
.content {
  width: 100%;

  .line {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .message {
    @extend %label-six-grey-three;
  }
}
</style>
